"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleTypesEnum = void 0;
exports.RoleTypesEnum = {
    // default and custom are used more as a concept than actual roles / constants
    DEFAULT: 'Default',
    CUSTOM: 'Custom',
    //region RoleTypes
    Accountant: 'Accountant',
    Admin: 'Admin',
    BondAdmin: 'Bond Admin',
    EmployeeManager: 'Employee Manager',
    FrontDesk: 'Front Desk',
    Instructor: 'Instructor',
    KioskStaff: 'Kiosk Staff',
    MaintenanceStaff: 'Maintenance Staff',
    Marketing: 'Marketing',
    MembershipsDirector: 'Memberships Director',
    ProgramDirector: 'Program Director',
    //endregion
};
//# sourceMappingURL=role.enums.js.map